"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldError = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../../Icon");
const FieldError_styles_1 = require("./FieldError.styles");
/**
 * And error message that is displayed below the field control
 */
const FieldError = react_1.default.forwardRef((props, forwardedRef) => {
    return (react_1.default.createElement(FieldError_styles_1.StyledFieldError, Object.assign({}, props, { ref: forwardedRef, role: "alert", "aria-live": "assertive" }),
        react_1.default.createElement(Icon_1.Icon, { name: "Error", color: "red", size: "small", appearance: "solid" }),
        props.children));
});
exports.FieldError = FieldError;
FieldError.displayName = "Field.Error";
//# sourceMappingURL=FieldError.js.map